document.addEventListener('DOMContentLoaded', function () {
  var button = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-nav]');
  if (!button || !menu) return;
  button.addEventListener('click', function () {
    var isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isOpen));
    menu.hidden = isOpen;
  });
});
